import { Box } from '@chakra-ui/react';
import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';
import { useSelectedView } from 'reducers/viewsSlice';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import {
  GROUP_BY_VALUES,
  setSelectedGroupBy,
  useSelectCompetenciesSelectedGroupBy,
} from '../slice/CompetenciesIntentSlice';

const CFGroupBy = () => {
  const sideNavSelectedCohort = useSelectedView();
  const dispatch = useDispatch();

  const modifiedGroupByKeys =
    sideNavSelectedCohort?.id === -2
      ? GROUP_BY_VALUES.filter(({ keyName }) => keyName !== 'orgTree')
      : GROUP_BY_VALUES.filter(({ keyName }) => keyName !== 'employeeId');

  const selectedGroupByValue = useSelectCompetenciesSelectedGroupBy(sideNavSelectedCohort?.id);

  const onClick = (val: 'employeeId' | 'competency' | 'orgTree') => {
    dispatch(
      setSelectedGroupBy({
        cohortId: sideNavSelectedCohort?.id,
        groupBy: val,
      })
    );
  };

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip className="chip-dropdown">
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
            Group by:
          </TextBodyMedium>
          <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
            <TextBodyMedium bold color="text.g1">
              {selectedGroupByValue?.displayName}
            </TextBodyMedium>
          </Box>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent align="start" style={{ minWidth: '200px' }}>
        <DropdownRadioGroup value={selectedGroupByValue?.keyName}>
          {modifiedGroupByKeys?.map(({ keyName, displayName }) => (
            // @ts-expect-error keyName is incorrectly typed
            <DropdownRadioItem key={keyName} value={keyName} onClick={() => onClick(keyName)}>
              {displayName}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};

export { CFGroupBy };
